(() => {
	'use strict';

	const DEBUG = true;
	const TAG = '[PNG PARALLAX]';
	const DESKTOP_MIN = 1024;

	function log(...args) {
		if (!DEBUG) return;
		console.log(TAG, ...args);
	}

	function warn(...args) {
		if (!DEBUG) return;
		console.warn(TAG, ...args);
	}

	function clamp(val, min, max) {
		return Math.min(Math.max(val, min), max);
	}

	function isDesktop() {
		return window.innerWidth >= DESKTOP_MIN;
	}

	function getParallaxEl(sectionEl, side) {
		// Preferito: wrapper dedicato (evita conflitti con transform di motion-element)
		const preferred = sectionEl.querySelector(`.parallax-layer[data-parallax="${side}"]`);
		if (preferred) return preferred;

		// Fallback: qualsiasi nodo con data-parallax (utile se hai messo l'attr su motion-element)
		return sectionEl.querySelector(`[data-parallax="${side}"]`);
	}

	function initSection(sectionEl) {
		const sectionId = sectionEl.getAttribute('data-section-id') || '(no-id)';
		log('initSection ->', sectionId);

		const leftEl = getParallaxEl(sectionEl, 'left');
		const rightEl = getParallaxEl(sectionEl, 'right');

		log('found elements ->', {
			sectionId,
			left: !!leftEl,
			right: !!rightEl,
			leftEl,
			rightEl
		});

		if (!leftEl && !rightEl) {
			warn('NO parallax elements found in section', sectionId);
			return;
		}

		let rafId = 0;
		let enabled = false;
		let updateCount = 0;

		function resetTransforms() {
			if (leftEl) leftEl.style.transform = '';
			if (rightEl) rightEl.style.transform = '';
		}

		function applyActiveStyles(active) {
			log('applyActiveStyles ->', sectionId, active);

			if (!active) {
				resetTransforms();
				if (leftEl) leftEl.style.willChange = '';
				if (rightEl) rightEl.style.willChange = '';
				return;
			}

			if (leftEl) leftEl.style.willChange = 'transform';
			if (rightEl) rightEl.style.willChange = 'transform';
		}

		function update() {
			rafId = 0;
			if (!enabled) return;

			const rect = sectionEl.getBoundingClientRect();
			const vh = window.innerHeight || 1;

			// progress 0..1 mentre attraversa la viewport
			const progress = clamp((vh - rect.top) / (vh + rect.height), 0, 1);
			// t -1..1 centrato
			const t = (progress - 0.5) * 2;

			// Ampiezze (come le tue)
			const leftAmp = 120;		// su leggero (verso l'alto)
			const rightAmp = 300;	// giù pesante

			if (leftEl) {
				const y = (-leftAmp * t);
				leftEl.style.transform = `translate3d(0, ${y.toFixed(2)}px, 0)`;
			}

			if (rightEl) {
				const y = (rightAmp * t);
				rightEl.style.transform = `translate3d(0, ${y.toFixed(2)}px, 0)`;
			}

			updateCount += 1;

			// Log ogni ~30 frame (non spam)
			if (DEBUG && updateCount % 30 === 1) {
				log('update tick ->', sectionId, {
					width: window.innerWidth,
					vh,
					rectTop: rect.top.toFixed(2),
					rectH: rect.height.toFixed(2),
					progress: progress.toFixed(3),
					t: t.toFixed(3),
					leftTransform: leftEl ? leftEl.style.transform : null,
					rightTransform: rightEl ? rightEl.style.transform : null
				});
			}
		}

		function requestTick() {
			if (rafId) return;
			rafId = requestAnimationFrame(update);
		}

		function enable() {
			if (enabled) return;

			enabled = true;
			log('ENABLED ->', sectionId, 'width:', window.innerWidth);

			applyActiveStyles(true);
			requestTick();

			window.addEventListener('scroll', requestTick, { passive: true });
			log('scroll listener attached ->', sectionId);
		}

		function disable() {
			if (!enabled) return;

			enabled = false;
			log('DISABLED ->', sectionId, 'width:', window.innerWidth);

			window.removeEventListener('scroll', requestTick);

			if (rafId) cancelAnimationFrame(rafId);
			rafId = 0;

			applyActiveStyles(false);
			log('scroll listener removed + transforms reset ->', sectionId);
		}

		function onResize() {
			const desktop = isDesktop();
			log('resize ->', sectionId, 'width:', window.innerWidth, 'desktop?', desktop);

			if (desktop) enable();
			else disable();
		}

		onResize();
		window.addEventListener('resize', onResize);
		log('resize listener attached ->', sectionId);
	}

	function init() {
		log('init() fired', {
			readyState: document.readyState,
			width: window.innerWidth,
			desktop: isDesktop()
		});

		const sections = document.querySelectorAll('.section-image-text-with-png[data-section-id]');
		log('sections found ->', sections.length);

		if (!sections.length) {
			warn('NO sections found with selector: .section-image-text-with-png[data-section-id]');
			return;
		}

		sections.forEach(initSection);
		log('init() done');
	}

	log('script loaded ✅');

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => {
			log('DOMContentLoaded ✅');
			init();
		});
	} else {
		init();
	}
})();
